export default function removeFirstValueFromBracketString(string) {
    const pattern = new RegExp(/> (.*)/);
    return string.match(pattern)[1];
}
